import { getAuthToken } from './auth';
import { getSelectedEnvironment } from '../utils/apiEnvironment';

export function landmarkBase(environment) {
  const base = environment === 'test'
    ? process.env.REACT_APP_LANDMARK_TEST_BASE
    : process.env.REACT_APP_LANDMARK_PROD_BASE;
  if (!base) throw new Error(`${environment.toUpperCase()} 랜드마크 API가 설정되지 않았습니다.`);
  // Local development uses the same-origin proxy; TEST currently allows localhost:3010, not :3000.
  if (environment === 'test' && process.env.NODE_ENV === 'development') return '/api-landmark-test';
  return base.replace(/\/$/, '');
}

export async function requestLandmarks(environment, path = '', options = {}) {
  if (environment !== getSelectedEnvironment()) throw new Error('환경이 변경되었습니다. 다시 불러와 주세요.');
  const token = getAuthToken();
  if (!token) throw new Error('로그인이 필요합니다.');
  const res = await fetch(`${landmarkBase(environment)}/admin/landmarks${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data.error || `요청 실패 (${res.status})`), { status: res.status });
  return data;
}

export async function uploadLandmarkFile(environment, file) {
  if (!file || !file.name.toLowerCase().endsWith('.glb') || file.size > 20 * 1024 * 1024) {
    throw new Error('20MB 이하의 GLB 파일을 선택해 주세요.');
  }
  const upload = await requestLandmarks(environment, '/uploads', { method: 'POST' });
  if (environment !== getSelectedEnvironment()) throw new Error('환경이 변경되었습니다.');
  const result = await fetch(upload.url, { method: 'PUT', headers: { 'Content-Type': 'model/gltf-binary' }, body: file });
  if (!result.ok) throw new Error('GLB 업로드에 실패했습니다.');
  return upload.key;
}
